/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EngageAISendMessageDto } from '../models';
import { SurveyDraftingMessageDto } from '../models';
import { SurveyDraftingSessionDto } from '../models';
/**
 * SurveyDraftingApi - axios parameter creator
 * @export
 */
export const SurveyDraftingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a survey draft session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDraftingControllerCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/survey-drafting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the list of messages for a specific OpenAI thread.
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDraftingControllerGetEngageAIMessages: async (threadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new RequiredError('threadId','Required parameter threadId was null or undefined when calling surveyDraftingControllerGetEngageAIMessages.');
            }
            const localVarPath = `/api/survey-drafting/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDraftingControllerGetRunStatus: async (runId: string, threadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            if (runId === null || runId === undefined) {
                throw new RequiredError('runId','Required parameter runId was null or undefined when calling surveyDraftingControllerGetRunStatus.');
            }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new RequiredError('threadId','Required parameter threadId was null or undefined when calling surveyDraftingControllerGetRunStatus.');
            }
            const localVarPath = `/api/survey-drafting/{threadId}/run-status/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a message to the Engagement's AI chat session for the current user
         * @param {EngageAISendMessageDto} body 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDraftingControllerSendEngageAIMessage: async (body: EngageAISendMessageDto, threadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling surveyDraftingControllerSendEngageAIMessage.');
            }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new RequiredError('threadId','Required parameter threadId was null or undefined when calling surveyDraftingControllerSendEngageAIMessage.');
            }
            const localVarPath = `/api/survey-drafting/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyDraftingApi - functional programming interface
 * @export
 */
export const SurveyDraftingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a survey draft session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SurveyDraftingSessionDto>>> {
            const localVarAxiosArgs = await SurveyDraftingApiAxiosParamCreator(configuration).surveyDraftingControllerCreate(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the list of messages for a specific OpenAI thread.
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerGetEngageAIMessages(threadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SurveyDraftingMessageDto>>> {
            const localVarAxiosArgs = await SurveyDraftingApiAxiosParamCreator(configuration).surveyDraftingControllerGetEngageAIMessages(threadId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerGetRunStatus(runId: string, threadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await SurveyDraftingApiAxiosParamCreator(configuration).surveyDraftingControllerGetRunStatus(runId, threadId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Sends a message to the Engagement's AI chat session for the current user
         * @param {EngageAISendMessageDto} body 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerSendEngageAIMessage(body: EngageAISendMessageDto, threadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await SurveyDraftingApiAxiosParamCreator(configuration).surveyDraftingControllerSendEngageAIMessage(body, threadId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SurveyDraftingApi - factory interface
 * @export
 */
export const SurveyDraftingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a survey draft session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerCreate(options?: AxiosRequestConfig): Promise<AxiosResponse<SurveyDraftingSessionDto>> {
            return SurveyDraftingApiFp(configuration).surveyDraftingControllerCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the list of messages for a specific OpenAI thread.
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerGetEngageAIMessages(threadId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<SurveyDraftingMessageDto>> {
            return SurveyDraftingApiFp(configuration).surveyDraftingControllerGetEngageAIMessages(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerGetRunStatus(runId: string, threadId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return SurveyDraftingApiFp(configuration).surveyDraftingControllerGetRunStatus(runId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a message to the Engagement's AI chat session for the current user
         * @param {EngageAISendMessageDto} body 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDraftingControllerSendEngageAIMessage(body: EngageAISendMessageDto, threadId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return SurveyDraftingApiFp(configuration).surveyDraftingControllerSendEngageAIMessage(body, threadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyDraftingApi - object-oriented interface
 * @export
 * @class SurveyDraftingApi
 * @extends {BaseAPI}
 */
export class SurveyDraftingApi extends BaseAPI {
    /**
     * 
     * @summary Create a survey draft session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDraftingApi
     */
    public async surveyDraftingControllerCreate(options?: AxiosRequestConfig) : Promise<AxiosResponse<SurveyDraftingSessionDto>> {
        return SurveyDraftingApiFp(this.configuration).surveyDraftingControllerCreate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns the list of messages for a specific OpenAI thread.
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDraftingApi
     */
    public async surveyDraftingControllerGetEngageAIMessages(threadId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<SurveyDraftingMessageDto>> {
        return SurveyDraftingApiFp(this.configuration).surveyDraftingControllerGetEngageAIMessages(threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets the status of a Run given the sessionId and runId
     * @param {string} runId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDraftingApi
     */
    public async surveyDraftingControllerGetRunStatus(runId: string, threadId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return SurveyDraftingApiFp(this.configuration).surveyDraftingControllerGetRunStatus(runId, threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Sends a message to the Engagement's AI chat session for the current user
     * @param {EngageAISendMessageDto} body 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDraftingApi
     */
    public async surveyDraftingControllerSendEngageAIMessage(body: EngageAISendMessageDto, threadId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return SurveyDraftingApiFp(this.configuration).surveyDraftingControllerSendEngageAIMessage(body, threadId, options).then((request) => request(this.axios, this.basePath));
    }
}
